import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export var INHERITED_NAME = Symbol('INHERITED_NAME');
function Enhancement() {
  return {
    condition: function condition(Component) {
      return Boolean(Component.displayName);
    },
    "static": function _static(WrapperComponent) {
      return _defineProperty({}, INHERITED_NAME, _toConsumableArray(new Set([].concat(_toConsumableArray(WrapperComponent[INHERITED_NAME] || []), [WrapperComponent.displayName]))));
    }
  };
}
export default Enhancement;
//# sourceMappingURL=inheritedName.mjs.map